import { motion, useReducedMotion } from "framer-motion";
import LeadForm from "../LeadForm";
import { MaskedHeading } from "../Reveal";
import { IMAGES } from "../../data/content";

export default function FinalCta() {
  const reduced = useReducedMotion();
  return (
    <section
      id="final-form"
      className="section relative overflow-hidden py-24 md:py-40"
      data-testid="final-cta-section"
    >
      {/* Horizon marin à l'aube */}
      <div className="absolute inset-0 z-0">
        <img
          src={IMAGES.shore}
          alt="Adulte marchant seul sur un rivage vaste au lever du soleil"
          loading="lazy"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-abyss via-abyss/85 to-abyss/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-abyss via-transparent to-abyss/60" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div className="max-w-xl">
            <span className="chapter-num">DERNIER APPEL</span>
            <MaskedHeading
              tag="h2"
              className="font-display font-medium text-[clamp(2.3rem,5vw,4.4rem)] leading-[1.02] tracking-tight text-pearl mt-6"
              lines={["Tu n'as pas besoin de connaître", "toute la traversée."]}
            />
            <p className="font-display italic text-[clamp(1.5rem,3.4vw,2.4rem)] text-aqua mt-3">
              Seulement d'accepter le premier pas.
            </p>

            <div className="mt-8 space-y-4 text-pearl/75 text-lg leading-relaxed">
              <p>Tu peux continuer à attendre que tout soit clair.</p>
              <p>Que la peur ait disparu.</p>
              <p>Que le bon moment se présente avec un panneau lumineux et une musique de film.</p>
              <p className="text-pearl">Ou tu peux simplement créer un espace.</p>
              <p className="font-display text-2xl text-aqua">
                Sept jours. Trois passages. Une expérience pour entendre autrement ce qui
                cherche à vivre en toi.
              </p>
            </div>
          </div>

          <motion.div
            initial={reduced ? { opacity: 0 } : { opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
            className="w-full lg:justify-self-end lg:max-w-md"
          >
            <LeadForm variant="final" formLocation="final" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
